export const GENERATE_REPORT = 'reporting/GENERATE_REPORT';
export const GENERATE_EXCEL_REPORT = 'reporting/GENERATE_EXCEL_REPORT';
export const DOWNLOAD_REPORT = 'reporting/DOWNLOAD_REPORT';
export const FETCH_REPORTS = 'reporting/FETCH_REPORTS';
export const FETCH_COMMENTS_BY_INVESTMENT_ID =
  'reporting/FETCH_COMMENTS_BY_INVESTMENT_ID';
export const FETCH_REPORT_PENSION_SCHEMES =
  'reporting/FETCH_REPORT_PENSION_SCHEMES';
export const FETCH_EXPOSED_SUB_FUNDS = 'reporting/FETCH_EXPOSED_SUB_FUNDS';
export const SET_SCHEMES_HAVING_EXPOSED_SUBFUNDS =
  'reporting/SET_SCHEMES_HAVING_EXPOSED_SUBFUNDS';
export const SET_REPORT_DATA_LOADING = 'reporting/SET_REPORT_DATA_LOADING';
